import React, { useState } from 'react';

const CustomThumbnailBar = ({ banners, current, onSelect }) => {
  const [expanded, setExpanded] = useState(false);
  const [hovered, setHovered] = useState(null); // index thumbnail đang hover

  const toggleExpand = () => setExpanded((prev) => !prev);

  return (
    <div
      style={{
        marginTop: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      {/* Vùng thumbnails */}
      <div
        className="thumbnails"
        style={{
          display: 'flex',
          flexWrap: expanded ? 'wrap' : 'nowrap',
          overflowX: expanded ? 'visible' : 'hidden',
          width: '85%',
          gap: 6,
          justifyContent: 'flex-start',
        }}
      >
        {banners.map((banner, index) => {
          const src = banner.image || banner; // hỗ trợ object lẫn string
          const colorName = banner.color_name ?? '?';

          return (
            <div
              key={index}
              onClick={() => onSelect(index)}
              onMouseEnter={() => setHovered(index)}
              onMouseLeave={() => setHovered(null)}
              style={{
                width: 'calc(25% - 6px / 4 * 3)',
                height: 60,
                cursor: 'pointer',
                border:
                  index === current
                    ? '2px solid var(--main-color)'
                    : '2px solid #ccc',
                borderRadius: 4,
                overflow: 'hidden',
                flexShrink: 0,
                position: 'relative', // để tooltip bám vào
              }}
            >
              <img
                src={src}
                alt={`thumb_${index}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />

              {/* Tooltip custom */}
              {hovered === index && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    background: 'rgba(0,0,0,0.75)',
                    color: '#fff',
                    padding: '2px 8px',
                    fontSize: 12,
                    borderRadius: 4,
                    whiteSpace: 'nowrap',
                    zIndex: 10,
                  }}
                >
                  {colorName}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Nút xem thêm đặt bên phải thumbnails */}
      {banners.length > 4 && (
        <button
          className='btn-thumpnail-more'
          onClick={toggleExpand}
          style={{
            padding: '0',
            fontSize: 14,
            borderRadius: 4,
            border: 'transparent',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            flexShrink: 0,
            width: 'calc(15% - 6px)',
            height: '60px',
            alignSelf: 'flex-start',
            fontWeight: 'bold',
          }}
        >
          {expanded ? '-' : '+'}{banners.length - 4}
        </button>
      )}
    </div>
  );
};

export default CustomThumbnailBar;
